export default "__VITE_ASSET__CzwEBJmr__"